import { render } from "./PageUpdates.vue?vue&type=template&id=081167e8&scoped=true"
import script from "./PageUpdates.vue?vue&type=script&lang=js"
export * from "./PageUpdates.vue?vue&type=script&lang=js"

import "./PageUpdates.vue?vue&type=style&index=0&id=081167e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081167e8"]])

export default __exports__